import * as _ from "lodash";
import { DirectionalHint, IconButton, TeachingBubble } from "office-ui-fabric-react";
import * as React from "react";
import { Component } from "react";
import { SubjectItem } from "./OnboardSubjectMergePage/SubjectItem";

export interface SubjectMergeCardProps {
    className?: string;
    subjectItem: SubjectItem;
    selected: boolean;
    onMergeClicked: (subjectItem: SubjectItem) => void;
    onUnmergeSubjectCode: (subjectItem: SubjectItem, subjectCode: string) => void;
    onDrag: (subjectItem: SubjectItem) => void;
    onDrop: (subjectItem: SubjectItem) => void;
}

interface SubjectMergeCardState {
    mergesTeachingBubbleVisible: boolean;
}

export default class SubjectMergeCard extends Component<SubjectMergeCardProps, SubjectMergeCardState>
{
    constructor(props: Readonly<SubjectMergeCardProps>) {
        super(props);

        this.state = {
            mergesTeachingBubbleVisible: false
        }
    }

    public componentDidMount() {
    }
    
    public static getIdForSubjectItem(subjectItem: SubjectItem): string {
        var sanitisedSubjectCode = subjectItem.code
            .replace(/ /g, '_')
            .replace(/\(/g, '_')
            .replace(/\)/g, '_');

        var subjectCodeId = "cdb_" + sanitisedSubjectCode;
        return subjectCodeId;
    }

    public render() {
        
        let className = `${this.props.className ? this.props.className : ""} subject-card`;
        if (this.props.selected) {
            className = `${className} subject-card--selected`;
        }

        const sortedMergedSubjects = _.sortBy([...this.props.subjectItem.mergedSubjects], ["subjectCode"]);
        const mergedSubjectsListItems = sortedMergedSubjects.map((mergedSubject) => {
            return (
                <li key={mergedSubject.subjectCode}>
                    {mergedSubject.subjectName ? `${mergedSubject.subjectName} (${mergedSubject.subjectCode})` : mergedSubject.subjectCode}
                    <a style={{ color: "white", fontStyle: "italic", cursor: "pointer", fontWeight: "bold", paddingLeft: "10px" }} onClick={() => { this.props.onUnmergeSubjectCode(this.props.subjectItem, mergedSubject.subjectCode); this.setState({ mergesTeachingBubbleVisible: !this.state.mergesTeachingBubbleVisible }) }}>
                        (remove)
                    </a>
                </li>
            );
        });

        const mergesTeachingBubbleToggle = (
            <span id={SubjectMergeCard.getIdForSubjectItem(this.props.subjectItem)} className={"subject-card__merge-count"} onClick={() => this.setState({ mergesTeachingBubbleVisible: !this.state.mergesTeachingBubbleVisible })}>
                {this.props.subjectItem.mergedSubjects.length} Merged Subjects
            </span>
        );

        const mergesTeachingBubble = (
            <TeachingBubble
                calloutProps={{ directionalHint: DirectionalHint.bottomCenter }}
                onDismiss={() => this.setState({ mergesTeachingBubbleVisible: !this.state.mergesTeachingBubbleVisible })}
                target={"#" + SubjectMergeCard.getIdForSubjectItem(this.props.subjectItem)}
                isWide={true}
                closeButtonAriaLabel="Close">
                Merged Subjects
                <ul>
                    {mergedSubjectsListItems}
                </ul>
            </TeachingBubble>
        );

        return (
            <div className={className}
                draggable
                onDragStart={() => this.props.onDrag(this.props.subjectItem)}
                onDrop={() => this.props.onDrop(this.props.subjectItem)}
                onDragEnter={(e) => e.preventDefault()}
                onDragOver={(e) => e.preventDefault()}>

                <div className={"subject-card__content"}>
                    <div className={"subject-card__header"}>
                        <div className={"flex-column flex-item--flex-1"}>
                            <span>{this.props.subjectItem.name}</span>
                            <span className={"subject-card__subject-code"}>{this.props.subjectItem.code}</span>
                        </div>
                        <IconButton className={"m-left-auto"} iconProps={{ iconName: "MergeDuplicate" }} title="Add" ariaLabel="Add" onClick={() => this.props.onMergeClicked(this.props.subjectItem)} />
                    </div>

                    {sortedMergedSubjects.length > 0 ? mergesTeachingBubbleToggle : null}

                    {this.state.mergesTeachingBubbleVisible ? mergesTeachingBubble : null}

                </div>

            </div>
        );
    }
}